import { jsx as i, Fragment as Q, jsxs as S } from "react/jsx-runtime";
import { useQuery as J } from "@tanstack/react-query";
import { Client as Nn, Query as B, Op as u, OrderBy as Re } from "contensis-delivery-api";
import * as l from "react";
import j, { useState as _, useEffect as ke } from "react";
import * as st from "react-dom";
import En from "react-dom";
import { twMerge as le } from "tailwind-merge";
import { motion as H } from "framer-motion";
import { useDebounceCallback as at } from "usehooks-ts";
import { format as We } from "date-fns";
import { cva as it } from "cva";
import Be from "sanitize-html";
const In = () => {
  if (typeof window < "u") {
    const e = window.location.hostname;
    return Rn(e);
  }
  return null;
}, Rn = (e) => e.startsWith("localhost") ? "latest" : e.endsWith("contensis.cloud") ? e.indexOf("preview.") > -1 ? "latest" : "published" : e.endsWith("cloud.contensis.com") && e.indexOf("preview-") > -1 ? "latest" : "published", kn = {
  rootUrl: "https://cms-uni-hull.cloud.contensis.com",
  accessToken: "rRdGBGOsFIIWzFDeXMz9Zf6gpSq8sidf5b2yeys4pqfDbQO7",
  projectId: "website",
  versionStatus: In()
}, L = Nn.create(kn), Pn = [
  "title",
  "image",
  "entryTitle",
  "entry",
  "pageUrl",
  "newPage",
  "externalTitle",
  "externalUrl",
  "secondaryLogo",
  "navItems",
  "navigationSecondaryLinks",
  "navigationArticles",
  "quickLinks",
  "uiLinks",
  "socialIcons",
  "searchType",
  "showSearchBar",
  "popularSearches",
  "footer",
  "awardsPartners",
  "address",
  "phone",
  "sys.uri"
], lt = async () => {
  try {
    return await L.entries.get({
      id: "58f56370-3165-460c-b9e9-abe4071a7509",
      fields: Pn,
      linkDepth: 1,
      fieldLinkDepths: {
        navItems: 2,
        footer: 2
      }
    });
  } catch (e) {
    console.log(e);
  }
};
function R(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function An(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ct(...e) {
  return (t) => e.forEach((n) => An(n, t));
}
function M(...e) {
  return l.useCallback(ct(...e), e);
}
function Fn(e, t) {
  const n = l.createContext(t);
  function r(s) {
    const { children: c, ...a } = s, f = l.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ i(n.Provider, { value: f, children: c });
  }
  function o(s) {
    const c = l.useContext(n);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, o];
}
function de(e, t = []) {
  let n = [];
  function r(s, c) {
    const a = l.createContext(c), f = n.length;
    n = [...n, c];
    function d(p) {
      const { scope: v, children: w, ...x } = p, h = (v == null ? void 0 : v[e][f]) || a, b = l.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ i(h.Provider, { value: b, children: w });
    }
    function g(p, v) {
      const w = (v == null ? void 0 : v[e][f]) || a, x = l.useContext(w);
      if (x) return x;
      if (c !== void 0) return c;
      throw new Error(`\`${p}\` must be used within \`${s}\``);
    }
    return d.displayName = s + "Provider", [d, g];
  }
  const o = () => {
    const s = n.map((c) => l.createContext(c));
    return function(a) {
      const f = (a == null ? void 0 : a[e]) || s;
      return l.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: f } }),
        [a, f]
      );
    };
  };
  return o.scopeName = e, [r, On(o, ...t)];
}
function On(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const c = r.reduce((a, { useScope: f, scopeName: d }) => {
        const p = f(s)[`__scope${d}`];
        return { ...a, ...p };
      }, {});
      return l.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var ce = globalThis != null && globalThis.document ? l.useLayoutEffect : () => {
}, Mn = l.useId || (() => {
}), Ln = 0;
function X(e) {
  const [t, n] = l.useState(Mn());
  return ce(() => {
    e || n((r) => r ?? String(Ln++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function q(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Pe({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = Dn({ defaultProp: t, onChange: n }), s = e !== void 0, c = s ? e : r, a = q(n), f = l.useCallback(
    (d) => {
      if (s) {
        const p = typeof d == "function" ? d(e) : d;
        p !== e && a(p);
      } else
        o(d);
    },
    [s, e, o, a]
  );
  return [c, f];
}
function Dn({
  defaultProp: e,
  onChange: t
}) {
  const n = l.useState(e), [r] = n, o = l.useRef(r), s = q(t);
  return l.useEffect(() => {
    o.current !== r && (s(r), o.current = r);
  }, [r, o, s]), n;
}
var Z = l.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = l.Children.toArray(n), s = o.find(qn);
  if (s) {
    const c = s.props.children, a = o.map((f) => f === s ? l.Children.count(c) > 1 ? l.Children.only(null) : l.isValidElement(c) ? c.props.children : null : f);
    return /* @__PURE__ */ i(Se, { ...r, ref: t, children: l.isValidElement(c) ? l.cloneElement(c, void 0, a) : null });
  }
  return /* @__PURE__ */ i(Se, { ...r, ref: t, children: n });
});
Z.displayName = "Slot";
var Se = l.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (l.isValidElement(n)) {
    const o = Bn(n);
    return l.cloneElement(n, {
      ...Wn(r, n.props),
      // @ts-ignore
      ref: t ? ct(t, o) : o
    });
  }
  return l.Children.count(n) > 1 ? l.Children.only(null) : null;
});
Se.displayName = "SlotClone";
var _n = ({ children: e }) => /* @__PURE__ */ i(Q, { children: e });
function qn(e) {
  return l.isValidElement(e) && e.type === _n;
}
function Wn(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      s(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Bn(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Un = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], k = Un.reduce((e, t) => {
  const n = l.forwardRef((r, o) => {
    const { asChild: s, ...c } = r, a = s ? Z : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ i(a, { ...c, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function jn(e, t) {
  e && st.flushSync(() => e.dispatchEvent(t));
}
function $n(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = q(e);
  l.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Vn = "DismissableLayer", Ce = "dismissableLayer.update", zn = "dismissableLayer.pointerDownOutside", Kn = "dismissableLayer.focusOutside", Ue, ut = l.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), dt = l.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: s,
      onInteractOutside: c,
      onDismiss: a,
      ...f
    } = e, d = l.useContext(ut), [g, p] = l.useState(null), v = (g == null ? void 0 : g.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, w] = l.useState({}), x = M(t, (N) => p(N)), h = Array.from(d.layers), [b] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(b), T = g ? h.indexOf(g) : -1, C = d.layersWithOutsidePointerEventsDisabled.size > 0, m = T >= y, E = Yn((N) => {
      const I = N.target, F = [...d.branches].some((V) => V.contains(I));
      !m || F || (o == null || o(N), c == null || c(N), N.defaultPrevented || a == null || a());
    }, v), P = Xn((N) => {
      const I = N.target;
      [...d.branches].some((V) => V.contains(I)) || (s == null || s(N), c == null || c(N), N.defaultPrevented || a == null || a());
    }, v);
    return $n((N) => {
      T === d.layers.size - 1 && (r == null || r(N), !N.defaultPrevented && a && (N.preventDefault(), a()));
    }, v), l.useEffect(() => {
      if (g)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Ue = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(g)), d.layers.add(g), je(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Ue);
        };
    }, [g, v, n, d]), l.useEffect(() => () => {
      g && (d.layers.delete(g), d.layersWithOutsidePointerEventsDisabled.delete(g), je());
    }, [g, d]), l.useEffect(() => {
      const N = () => w({});
      return document.addEventListener(Ce, N), () => document.removeEventListener(Ce, N);
    }, []), /* @__PURE__ */ i(
      k.div,
      {
        ...f,
        ref: x,
        style: {
          pointerEvents: C ? m ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: R(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: R(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: R(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
dt.displayName = Vn;
var Gn = "DismissableLayerBranch", Hn = l.forwardRef((e, t) => {
  const n = l.useContext(ut), r = l.useRef(null), o = M(t, r);
  return l.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ i(k.div, { ...e, ref: o });
});
Hn.displayName = Gn;
function Yn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = q(e), r = l.useRef(!1), o = l.useRef(() => {
  });
  return l.useEffect(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let f = function() {
          ft(
            zn,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Xn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = q(e), r = l.useRef(!1);
  return l.useEffect(() => {
    const o = (s) => {
      s.target && !r.current && ft(Kn, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function je() {
  const e = new CustomEvent(Ce);
  document.dispatchEvent(e);
}
function ft(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? jn(o, s) : o.dispatchEvent(s);
}
var pe = "focusScope.autoFocusOnMount", ve = "focusScope.autoFocusOnUnmount", $e = { bubbles: !1, cancelable: !0 }, Qn = "FocusScope", ht = l.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s,
    ...c
  } = e, [a, f] = l.useState(null), d = q(o), g = q(s), p = l.useRef(null), v = M(t, (h) => f(h)), w = l.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  l.useEffect(() => {
    if (r) {
      let h = function(C) {
        if (w.paused || !a) return;
        const m = C.target;
        a.contains(m) ? p.current = m : D(p.current, { select: !0 });
      }, b = function(C) {
        if (w.paused || !a) return;
        const m = C.relatedTarget;
        m !== null && (a.contains(m) || D(p.current, { select: !0 }));
      }, y = function(C) {
        if (document.activeElement === document.body)
          for (const E of C)
            E.removedNodes.length > 0 && D(a);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const T = new MutationObserver(y);
      return a && T.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), T.disconnect();
      };
    }
  }, [r, a, w.paused]), l.useEffect(() => {
    if (a) {
      ze.add(w);
      const h = document.activeElement;
      if (!a.contains(h)) {
        const y = new CustomEvent(pe, $e);
        a.addEventListener(pe, d), a.dispatchEvent(y), y.defaultPrevented || (Zn(rr(gt(a)), { select: !0 }), document.activeElement === h && D(a));
      }
      return () => {
        a.removeEventListener(pe, d), setTimeout(() => {
          const y = new CustomEvent(ve, $e);
          a.addEventListener(ve, g), a.dispatchEvent(y), y.defaultPrevented || D(h ?? document.body, { select: !0 }), a.removeEventListener(ve, g), ze.remove(w);
        }, 0);
      };
    }
  }, [a, d, g, w]);
  const x = l.useCallback(
    (h) => {
      if (!n && !r || w.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (b && y) {
        const T = h.currentTarget, [C, m] = Jn(T);
        C && m ? !h.shiftKey && y === m ? (h.preventDefault(), n && D(C, { select: !0 })) : h.shiftKey && y === C && (h.preventDefault(), n && D(m, { select: !0 })) : y === T && h.preventDefault();
      }
    },
    [n, r, w.paused]
  );
  return /* @__PURE__ */ i(k.div, { tabIndex: -1, ...c, ref: v, onKeyDown: x });
});
ht.displayName = Qn;
function Zn(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (D(r, { select: t }), document.activeElement !== n) return;
}
function Jn(e) {
  const t = gt(e), n = Ve(t, e), r = Ve(t.reverse(), e);
  return [n, r];
}
function gt(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ve(e, t) {
  for (const n of e)
    if (!er(n, { upTo: t })) return n;
}
function er(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function tr(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function D(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && tr(e) && t && e.select();
  }
}
var ze = nr();
function nr() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ke(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ke(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Ke(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function rr(e) {
  return e.filter((t) => t.tagName !== "A");
}
var or = "Portal", pt = l.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, s] = l.useState(!1);
  ce(() => s(!0), []);
  const c = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return c ? En.createPortal(/* @__PURE__ */ i(k.div, { ...r, ref: t }), c) : null;
});
pt.displayName = or;
function sr(e, t) {
  return l.useReducer((n, r) => t[n][r] ?? n, e);
}
var ee = (e) => {
  const { present: t, children: n } = e, r = ar(t), o = typeof n == "function" ? n({ present: r.isPresent }) : l.Children.only(n), s = M(r.ref, ir(o));
  return typeof n == "function" || r.isPresent ? l.cloneElement(o, { ref: s }) : null;
};
ee.displayName = "Presence";
function ar(e) {
  const [t, n] = l.useState(), r = l.useRef({}), o = l.useRef(e), s = l.useRef("none"), c = e ? "mounted" : "unmounted", [a, f] = sr(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return l.useEffect(() => {
    const d = te(r.current);
    s.current = a === "mounted" ? d : "none";
  }, [a]), ce(() => {
    const d = r.current, g = o.current;
    if (g !== e) {
      const v = s.current, w = te(d);
      e ? f("MOUNT") : w === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(g && v !== w ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), ce(() => {
    if (t) {
      const d = (p) => {
        const w = te(r.current).includes(p.animationName);
        p.target === t && w && st.flushSync(() => f("ANIMATION_END"));
      }, g = (p) => {
        p.target === t && (s.current = te(r.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: l.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function te(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ir(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var me = 0;
function lr() {
  l.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ge()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ge()), me++, () => {
      me === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), me--;
    };
  }, []);
}
function Ge() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var O = function() {
  return O = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, O.apply(this, arguments);
};
function vt(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function cr(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var ae = "right-scroll-bar-position", ie = "width-before-scroll-bar", ur = "with-scroll-bars-hidden", dr = "--removed-body-scroll-bar-size";
function ye(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function fr(e, t) {
  var n = _(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var hr = typeof window < "u" ? l.useLayoutEffect : l.useEffect, He = /* @__PURE__ */ new WeakMap();
function gr(e, t) {
  var n = fr(null, function(r) {
    return e.forEach(function(o) {
      return ye(o, r);
    });
  });
  return hr(function() {
    var r = He.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), c = n.current;
      o.forEach(function(a) {
        s.has(a) || ye(a, null);
      }), s.forEach(function(a) {
        o.has(a) || ye(a, c);
      });
    }
    He.set(n, e);
  }, [e]), n;
}
function pr(e) {
  return e;
}
function vr(e, t) {
  t === void 0 && (t = pr);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var c = t(s, r);
      return n.push(c), function() {
        n = n.filter(function(a) {
          return a !== c;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var c = n;
        n = [], c.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var c = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), c = n;
      }
      var f = function() {
        var g = c;
        c = [], g.forEach(s);
      }, d = function() {
        return Promise.resolve().then(f);
      };
      d(), n = {
        push: function(g) {
          c.push(g), d();
        },
        filter: function(g) {
          return c = c.filter(g), n;
        }
      };
    }
  };
  return o;
}
function mr(e) {
  e === void 0 && (e = {});
  var t = vr(null);
  return t.options = O({ async: !0, ssr: !1 }, e), t;
}
var mt = function(e) {
  var t = e.sideCar, n = vt(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return l.createElement(r, O({}, n));
};
mt.isSideCarExport = !0;
function yr(e, t) {
  return e.useMedium(t), mt;
}
var yt = mr(), be = function() {
}, fe = l.forwardRef(function(e, t) {
  var n = l.useRef(null), r = l.useState({
    onScrollCapture: be,
    onWheelCapture: be,
    onTouchMoveCapture: be
  }), o = r[0], s = r[1], c = e.forwardProps, a = e.children, f = e.className, d = e.removeScrollBar, g = e.enabled, p = e.shards, v = e.sideCar, w = e.noIsolation, x = e.inert, h = e.allowPinchZoom, b = e.as, y = b === void 0 ? "div" : b, T = e.gapMode, C = vt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), m = v, E = gr([n, t]), P = O(O({}, C), o);
  return l.createElement(
    l.Fragment,
    null,
    g && l.createElement(m, { sideCar: yt, removeScrollBar: d, shards: p, noIsolation: w, inert: x, setCallbacks: s, allowPinchZoom: !!h, lockRef: n, gapMode: T }),
    c ? l.cloneElement(l.Children.only(a), O(O({}, P), { ref: E })) : l.createElement(y, O({}, P, { className: f, ref: E }), a)
  );
});
fe.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
fe.classNames = {
  fullWidth: ie,
  zeroRight: ae
};
var br = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function wr() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = br();
  return t && e.setAttribute("nonce", t), e;
}
function xr(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Tr(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Sr = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = wr()) && (xr(t, n), Tr(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Cr = function() {
  var e = Sr();
  return function(t, n) {
    l.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, bt = function() {
  var e = Cr(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Nr = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, we = function(e) {
  return parseInt(e || "", 10) || 0;
}, Er = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [we(n), we(r), we(o)];
}, Ir = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Nr;
  var t = Er(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Rr = bt(), Y = "data-scroll-locked", kr = function(e, t, n, r) {
  var o = e.left, s = e.top, c = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(ur, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(Y, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ae, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ie, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ae, " .").concat(ae, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ie, " .").concat(ie, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Y, `] {
    `).concat(dr, ": ").concat(a, `px;
  }
`);
}, Ye = function() {
  var e = parseInt(document.body.getAttribute(Y) || "0", 10);
  return isFinite(e) ? e : 0;
}, Pr = function() {
  l.useEffect(function() {
    return document.body.setAttribute(Y, (Ye() + 1).toString()), function() {
      var e = Ye() - 1;
      e <= 0 ? document.body.removeAttribute(Y) : document.body.setAttribute(Y, e.toString());
    };
  }, []);
}, Ar = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Pr();
  var s = l.useMemo(function() {
    return Ir(o);
  }, [o]);
  return l.createElement(Rr, { styles: kr(s, !t, o, n ? "" : "!important") });
}, Ne = !1;
if (typeof window < "u")
  try {
    var ne = Object.defineProperty({}, "passive", {
      get: function() {
        return Ne = !0, !0;
      }
    });
    window.addEventListener("test", ne, ne), window.removeEventListener("test", ne, ne);
  } catch {
    Ne = !1;
  }
var z = Ne ? { passive: !1 } : !1, Fr = function(e) {
  return e.tagName === "TEXTAREA";
}, wt = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Fr(e) && n[t] === "visible")
  );
}, Or = function(e) {
  return wt(e, "overflowY");
}, Mr = function(e) {
  return wt(e, "overflowX");
}, Xe = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = xt(e, r);
    if (o) {
      var s = Tt(e, r), c = s[1], a = s[2];
      if (c > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Lr = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Dr = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, xt = function(e, t) {
  return e === "v" ? Or(t) : Mr(t);
}, Tt = function(e, t) {
  return e === "v" ? Lr(t) : Dr(t);
}, _r = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, qr = function(e, t, n, r, o) {
  var s = _r(e, window.getComputedStyle(t).direction), c = s * r, a = n.target, f = t.contains(a), d = !1, g = c > 0, p = 0, v = 0;
  do {
    var w = Tt(e, a), x = w[0], h = w[1], b = w[2], y = h - b - s * x;
    (x || y) && xt(e, a) && (p += y, v += x), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !f && a !== document.body || // self content
    f && (t.contains(a) || t === a)
  );
  return (g && (Math.abs(p) < 1 || !o) || !g && (Math.abs(v) < 1 || !o)) && (d = !0), d;
}, re = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Qe = function(e) {
  return [e.deltaX, e.deltaY];
}, Ze = function(e) {
  return e && "current" in e ? e.current : e;
}, Wr = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Br = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Ur = 0, K = [];
function jr(e) {
  var t = l.useRef([]), n = l.useRef([0, 0]), r = l.useRef(), o = l.useState(Ur++)[0], s = l.useState(bt)[0], c = l.useRef(e);
  l.useEffect(function() {
    c.current = e;
  }, [e]), l.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = cr([e.lockRef.current], (e.shards || []).map(Ze), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = l.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2)
      return !c.current.allowPinchZoom;
    var y = re(h), T = n.current, C = "deltaX" in h ? h.deltaX : T[0] - y[0], m = "deltaY" in h ? h.deltaY : T[1] - y[1], E, P = h.target, N = Math.abs(C) > Math.abs(m) ? "h" : "v";
    if ("touches" in h && N === "h" && P.type === "range")
      return !1;
    var I = Xe(N, P);
    if (!I)
      return !0;
    if (I ? E = N : (E = N === "v" ? "h" : "v", I = Xe(N, P)), !I)
      return !1;
    if (!r.current && "changedTouches" in h && (C || m) && (r.current = E), !E)
      return !0;
    var F = r.current || E;
    return qr(F, b, h, F === "h" ? C : m, !0);
  }, []), f = l.useCallback(function(h) {
    var b = h;
    if (!(!K.length || K[K.length - 1] !== s)) {
      var y = "deltaY" in b ? Qe(b) : re(b), T = t.current.filter(function(E) {
        return E.name === b.type && (E.target === b.target || b.target === E.shadowParent) && Wr(E.delta, y);
      })[0];
      if (T && T.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!T) {
        var C = (c.current.shards || []).map(Ze).filter(Boolean).filter(function(E) {
          return E.contains(b.target);
        }), m = C.length > 0 ? a(b, C[0]) : !c.current.noIsolation;
        m && b.cancelable && b.preventDefault();
      }
    }
  }, []), d = l.useCallback(function(h, b, y, T) {
    var C = { name: h, delta: b, target: y, should: T, shadowParent: $r(y) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(m) {
        return m !== C;
      });
    }, 1);
  }, []), g = l.useCallback(function(h) {
    n.current = re(h), r.current = void 0;
  }, []), p = l.useCallback(function(h) {
    d(h.type, Qe(h), h.target, a(h, e.lockRef.current));
  }, []), v = l.useCallback(function(h) {
    d(h.type, re(h), h.target, a(h, e.lockRef.current));
  }, []);
  l.useEffect(function() {
    return K.push(s), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", f, z), document.addEventListener("touchmove", f, z), document.addEventListener("touchstart", g, z), function() {
      K = K.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", f, z), document.removeEventListener("touchmove", f, z), document.removeEventListener("touchstart", g, z);
    };
  }, []);
  var w = e.removeScrollBar, x = e.inert;
  return l.createElement(
    l.Fragment,
    null,
    x ? l.createElement(s, { styles: Br(o) }) : null,
    w ? l.createElement(Ar, { gapMode: e.gapMode }) : null
  );
}
function $r(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Vr = yr(yt, jr);
var St = l.forwardRef(function(e, t) {
  return l.createElement(fe, O({}, e, { ref: t, sideCar: Vr }));
});
St.classNames = fe.classNames;
var zr = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, G = /* @__PURE__ */ new WeakMap(), oe = /* @__PURE__ */ new WeakMap(), se = {}, xe = 0, Ct = function(e) {
  return e && (e.host || Ct(e.parentNode));
}, Kr = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ct(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Gr = function(e, t, n, r) {
  var o = Kr(t, Array.isArray(e) ? e : [e]);
  se[n] || (se[n] = /* @__PURE__ */ new WeakMap());
  var s = se[n], c = [], a = /* @__PURE__ */ new Set(), f = new Set(o), d = function(p) {
    !p || a.has(p) || (a.add(p), d(p.parentNode));
  };
  o.forEach(d);
  var g = function(p) {
    !p || f.has(p) || Array.prototype.forEach.call(p.children, function(v) {
      if (a.has(v))
        g(v);
      else
        try {
          var w = v.getAttribute(r), x = w !== null && w !== "false", h = (G.get(v) || 0) + 1, b = (s.get(v) || 0) + 1;
          G.set(v, h), s.set(v, b), c.push(v), h === 1 && x && oe.set(v, !0), b === 1 && v.setAttribute(n, "true"), x || v.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", v, y);
        }
    });
  };
  return g(t), a.clear(), xe++, function() {
    c.forEach(function(p) {
      var v = G.get(p) - 1, w = s.get(p) - 1;
      G.set(p, v), s.set(p, w), v || (oe.has(p) || p.removeAttribute(r), oe.delete(p)), w || p.removeAttribute(n);
    }), xe--, xe || (G = /* @__PURE__ */ new WeakMap(), G = /* @__PURE__ */ new WeakMap(), oe = /* @__PURE__ */ new WeakMap(), se = {});
  };
}, Hr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = zr(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Gr(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Ae = "Dialog", [Nt, ds] = de(Ae), [Yr, A] = Nt(Ae), Et = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: c = !0
  } = e, a = l.useRef(null), f = l.useRef(null), [d = !1, g] = Pe({
    prop: r,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ i(
    Yr,
    {
      scope: t,
      triggerRef: a,
      contentRef: f,
      contentId: X(),
      titleId: X(),
      descriptionId: X(),
      open: d,
      onOpenChange: g,
      onOpenToggle: l.useCallback(() => g((p) => !p), [g]),
      modal: c,
      children: n
    }
  );
};
Et.displayName = Ae;
var It = "DialogTrigger", Rt = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = A(It, n), s = M(t, o.triggerRef);
    return /* @__PURE__ */ i(
      k.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Me(o.open),
        ...r,
        ref: s,
        onClick: R(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Rt.displayName = It;
var Fe = "DialogPortal", [Xr, kt] = Nt(Fe, {
  forceMount: void 0
}), Pt = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, s = A(Fe, t);
  return /* @__PURE__ */ i(Xr, { scope: t, forceMount: n, children: l.Children.map(r, (c) => /* @__PURE__ */ i(ee, { present: n || s.open, children: /* @__PURE__ */ i(pt, { asChild: !0, container: o, children: c }) })) });
};
Pt.displayName = Fe;
var ue = "DialogOverlay", At = l.forwardRef(
  (e, t) => {
    const n = kt(ue, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = A(ue, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ i(ee, { present: r || s.open, children: /* @__PURE__ */ i(Qr, { ...o, ref: t }) }) : null;
  }
);
At.displayName = ue;
var Qr = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = A(ue, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ i(St, { as: Z, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ i(
        k.div,
        {
          "data-state": Me(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), $ = "DialogContent", Ft = l.forwardRef(
  (e, t) => {
    const n = kt($, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = A($, e.__scopeDialog);
    return /* @__PURE__ */ i(ee, { present: r || s.open, children: s.modal ? /* @__PURE__ */ i(Zr, { ...o, ref: t }) : /* @__PURE__ */ i(Jr, { ...o, ref: t }) });
  }
);
Ft.displayName = $;
var Zr = l.forwardRef(
  (e, t) => {
    const n = A($, e.__scopeDialog), r = l.useRef(null), o = M(t, n.contentRef, r);
    return l.useEffect(() => {
      const s = r.current;
      if (s) return Hr(s);
    }, []), /* @__PURE__ */ i(
      Ot,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: R(e.onCloseAutoFocus, (s) => {
          var c;
          s.preventDefault(), (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: R(e.onPointerDownOutside, (s) => {
          const c = s.detail.originalEvent, a = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || a) && s.preventDefault();
        }),
        onFocusOutside: R(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), Jr = l.forwardRef(
  (e, t) => {
    const n = A($, e.__scopeDialog), r = l.useRef(!1), o = l.useRef(!1);
    return /* @__PURE__ */ i(
      Ot,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var c, a;
          (c = e.onCloseAutoFocus) == null || c.call(e, s), s.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), s.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (s) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const c = s.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(c)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
        }
      }
    );
  }
), Ot = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...c } = e, a = A($, n), f = l.useRef(null), d = M(t, f);
    return lr(), /* @__PURE__ */ S(Q, { children: [
      /* @__PURE__ */ i(
        ht,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ i(
            dt,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": Me(a.open),
              ...c,
              ref: d,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ S(Q, { children: [
        /* @__PURE__ */ i(eo, { titleId: a.titleId }),
        /* @__PURE__ */ i(no, { contentRef: f, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Oe = "DialogTitle", Mt = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = A(Oe, n);
    return /* @__PURE__ */ i(k.h2, { id: o.titleId, ...r, ref: t });
  }
);
Mt.displayName = Oe;
var Lt = "DialogDescription", Dt = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = A(Lt, n);
    return /* @__PURE__ */ i(k.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Dt.displayName = Lt;
var _t = "DialogClose", qt = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = A(_t, n);
    return /* @__PURE__ */ i(
      k.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: R(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
qt.displayName = _t;
function Me(e) {
  return e ? "open" : "closed";
}
var Wt = "DialogTitleWarning", [fs, Bt] = Fn(Wt, {
  contentName: $,
  titleName: Oe,
  docsSlug: "dialog"
}), eo = ({ titleId: e }) => {
  const t = Bt(Wt), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return l.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, to = "DialogDescriptionWarning", no = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Bt(to).contentName}}.`;
  return l.useEffect(() => {
    var s;
    const o = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, ro = Et, oo = Rt, so = Pt, Ut = At, jt = Ft, $t = Mt, Vt = Dt, ao = qt;
function zt(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = zt(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function io() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = zt(e)) && (r && (r += " "), r += t);
  return r;
}
const Je = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, et = io, lo = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return et(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: s } = t, c = Object.keys(o).map((d) => {
    const g = n == null ? void 0 : n[d], p = s == null ? void 0 : s[d];
    if (g === null) return null;
    const v = Je(g) || Je(p);
    return o[d][v];
  }), a = n && Object.entries(n).reduce((d, g) => {
    let [p, v] = g;
    return v === void 0 || (d[p] = v), d;
  }, {}), f = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, g) => {
    let { class: p, className: v, ...w } = g;
    return Object.entries(w).every((x) => {
      let [h, b] = x;
      return Array.isArray(b) ? b.includes({
        ...s,
        ...a
      }[h]) : {
        ...s,
        ...a
      }[h] === b;
    }) ? [
      ...d,
      p,
      v
    ] : d;
  }, []);
  return et(e, c, f, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Kt(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Kt(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function co() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Kt(e)) && (r && (r += " "), r += t);
  return r;
}
function W(...e) {
  return le(co(e));
}
const Gt = ro, Ht = oo, uo = ao, fo = so, ho = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  Ut,
  {
    className: W(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
ho.displayName = Ut.displayName;
const go = lo(
  "fixed z-50 gap-4 bg-white p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 dark:bg-slate-950",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Le = l.forwardRef(
  ({ side: e = "right", className: t, children: n, ...r }, o) => /* @__PURE__ */ S(fo, { children: [
    !(t != null && t.includes("no-overlay")) && /* @__PURE__ */ i(
      "div",
      {
        className: W(
          "fixed inset-0 z-50 bg-black/50  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        )
      }
    ),
    /* @__PURE__ */ i(jt, { ref: o, className: W(go({ side: e }), t), ...r, children: n })
  ] })
);
Le.displayName = jt.displayName;
const De = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  $t,
  {
    ref: n,
    className: W("text-slate-950 dark:text-slate-50 text-lg font-semibold", e),
    ...t
  }
));
De.displayName = $t.displayName;
const po = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  Vt,
  {
    ref: n,
    className: W("text-slate-500 dark:text-slate-400 text-sm", e),
    ...t
  }
));
po.displayName = Vt.displayName;
function vo(e) {
  const t = e.fill || "currentColor", n = e.secondaryfill || t, r = e.title || "menu icon";
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "35",
      width: "35",
      viewBox: "0 0 48 48",
      children: [
        /* @__PURE__ */ i("title", { children: r }),
        /* @__PURE__ */ S(
          "g",
          {
            strokeLinecap: "square",
            strokeWidth: "3",
            fill: n,
            stroke: n,
            strokeLinejoin: "miter",
            strokeMiterlimit: "10",
            children: [
              /* @__PURE__ */ S("g", { className: "js-nc-int-icon nc-int-menu", children: [
                /* @__PURE__ */ i("line", { x1: "24", y1: "10", x2: "46", y2: "10", stroke: t }),
                /* @__PURE__ */ i("line", { x1: "2", y1: "24", x2: "46", y2: "24", stroke: t }),
                /* @__PURE__ */ i("line", { x1: "2", y1: "38", x2: "24", y2: "38", stroke: t })
              ] }),
              /* @__PURE__ */ i("style", { children: ".menu{transition:background 0.2s ease-in-out}.menu .nc-int-menu :first-child,.nc-int-menu :last-child{stroke-dasharray:46;stroke-dashoffset:16;transition:transform 0.3s cubic-bezier(.17,.84,.44,1)}.menu:hover,.menu.active{background:#d7f777}.menu:hover>svg line,.menu.active>svg line{fill:#0e1647;stroke:#0e1647}.menu:hover .nc-int-menu :first-child, .menu.active .nc-int-menu :first-child{transform:translateX(-22px)}.menu:hover .nc-int-menu :last-child, .menu.active .nc-int-menu :last-child{transform:translateX(22px)}" })
            ]
          }
        )
      ]
    }
  );
}
function mo(e) {
  const t = e.fill || "currentColor", n = e.secondaryfill || t, r = e.title || "search icon";
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "35",
      width: "35",
      viewBox: "0 0 48 48",
      children: [
        /* @__PURE__ */ i("title", { children: r }),
        /* @__PURE__ */ S(
          "g",
          {
            strokeLinecap: "square",
            strokeWidth: "3",
            fill: "none",
            stroke: n,
            strokeLinejoin: "miter",
            strokeMiterlimit: "10",
            children: [
              /* @__PURE__ */ S("g", { className: "js-nc-int-icon nc-int-search", children: [
                /* @__PURE__ */ i("line", { x1: "44", y1: "44", x2: "31.314", y2: "31.314", stroke: t }),
                /* @__PURE__ */ i("circle", { cx: "20", cy: "20", r: "16", stroke: t })
              ] }),
              /* @__PURE__ */ i("style", { children: ".search{transition:background 0.2s ease-in-out}.search .nc-int-search{transition:all 0.3s cubic-bezier(.17,.84,.44,1);transform:rotate(0);transform-origin:center}.search:hover,.search.active{background:#d7f777}.search:hover>svg line,.search.active>svg line,.search:hover>svg circle,.search.active>svg circle{stroke:#0e1647}.search:hover .nc-int-search, .search.active .nc-int-search{transform:rotate(-90deg)}" })
            ]
          }
        )
      ]
    }
  );
}
const yo = ({ data: e }) => /* @__PURE__ */ i("div", { className: "flex h-full grow basis-[calc(50%-25px)] flex-col gap-8 overflow-auto md:gap-14", children: e == null ? void 0 : e.map((t, n) => {
  var r;
  return /* @__PURE__ */ S("div", { children: [
    /* @__PURE__ */ i("p", { className: "mb-4 text-[14px] uppercase leading-[21px] tracking-[1.6px] opacity-80 md:mb-6 md:text-[16px]", children: t == null ? void 0 : t.sectionTitle }),
    /* @__PURE__ */ i("ul", { className: "flex flex-col gap-3 md:gap-4", children: (r = t == null ? void 0 : t.uiSimpleLinks) == null ? void 0 : r.map((o, s) => {
      var c, a, f;
      return /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i(
        "a",
        {
          href: ((c = o == null ? void 0 : o.entry) == null ? void 0 : c.pageUrl) || (o == null ? void 0 : o.link),
          className: [
            `${t.largeLinks ? "text-[18px] md:text-h4" : ""}`,
            "font-bold hover:underline"
          ].join(" "),
          title: ((a = o == null ? void 0 : o.linkTitle) == null ? void 0 : a.toString()) || ((f = o == null ? void 0 : o.entry.entryTitle) == null ? void 0 : f.toString()),
          children: (o == null ? void 0 : o.linkTitle) || (o == null ? void 0 : o.entry.entryTitle)
        }
      ) }, s);
    }) })
  ] }, n);
}) }), tt = async (e, t = 3) => {
  const n = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.or(
      u.equalTo("entryTitle", e).weight(8),
      u.startsWith("entryTitle", e).weight(4),
      u.freeText("entryTitle", e, !0).weight(6),
      u.freeText("seoStandardFields.websiteDescription", e, !0).weight(2),
      u.freeText("seoStandardFields.description", e, !0).weight(2),
      u.freeText("seoStandardFields.keywords", e).weight(2),
      u.freeText("modules.coursesModuleCategory.modules.entryTitle", e, !0).weight(1),
      u.freeText("searchContent", e).weight(1)
    ),
    u.or(
      u.and(
        u.equalTo("sys.dataFormat", "webpage"),
        u.equalTo("sys.metadata.includeInSearch", !0),
        u.not(u.equalTo("sys.contentTypeId", "undergraduateCoursesWebpage")),
        u.not(u.startsWith("sys.contentTypeId", "scpgtCoursesWebpage")),
        u.not(u.startsWith("sys.contentTypeId", "scpgrCoursesWebpage")),
        u.not(u.startsWith("sys.contentTypeId", "scPhDWebpage")),
        u.not(u.startsWith("sys.contentTypeId", "cpdCoursesWebpage")),
        u.not(u.startsWith("sys.contentTypeId", "newsArticlesWebpage"))
      ),
      u.and(
        u.equalTo("sys.dataFormat", "entry"),
        u.contains("seoStandardFields.includeInSearch", "true"),
        // hides 500ish results
        u.not(u.contains("entryTitle", "Dummy")),
        u.not(u.startsWith("entryTitle", "DevTest")),
        u.or(
          u.equalTo("sys.contentTypeId", "coursesUndergraduate"),
          u.equalTo("sys.contentTypeId", "coursesPostgraduateTaught"),
          u.equalTo("sys.contentTypeId", "pgrCourses"),
          u.equalTo("sys.contentTypeId", "phdScholarships"),
          u.equalTo("sys.contentTypeId", "cpdCourses"),
          u.equalTo("sys.contentTypeId", "pgceCourses"),
          u.equalTo("sys.contentTypeId", "otherCourses"),
          u.equalTo("sys.contentTypeId", "newsArticles")
        )
      )
    )
  );
  n.pageSize = t, n.fields = [
    "entryTitle",
    "sys.uri",
    "pageUrl",
    "title",
    "keywords",
    "description",
    "sys",
    "searchContent",
    "thumbnail",
    "sys.metadata.profileImage",
    "seoStandardFields",
    "modules",
    "courseLength",
    "studyLevel",
    "coursesEntryRequirements.whichVariant",
    "coursesEntryRequirements.ucasPoints",
    "coursesVariant.whichVariant",
    "coursesVariant.ucasCode",
    "coursesVariant.studyMode",
    "tags",
    "date"
  ];
  try {
    return await L.entries.search(n);
  } catch (r) {
    console.log(r);
  }
}, Ee = async (e, t = 3) => {
  const n = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("sys.dataFormat", "entry"),
    u.contains("seoStandardFields.includeInSearch", "true"),
    u.or(
      u.equalTo("entryTitle", e).weight(8),
      u.startsWith("entryTitle", e).weight(4),
      u.freeText("entryTitle", e, !0).weight(6),
      u.freeText("seoStandardFields.websiteDescription", e, !0).weight(2),
      u.freeText("seoStandardFields.description", e, !0).weight(2),
      u.freeText("seoStandardFields.keywords", e).weight(2),
      u.freeText("modules.coursesModuleCategory.modules.entryTitle", e, !0).weight(1),
      u.freeText("searchContent", e).weight(1)
    ),
    u.or(
      u.equalTo("sys.contentTypeId", "coursesUndergraduate"),
      u.equalTo("sys.contentTypeId", "coursesPostgraduateTaught"),
      u.equalTo("sys.contentTypeId", "pgrCourses"),
      u.equalTo("sys.contentTypeId", "phdScholarships"),
      u.equalTo("sys.contentTypeId", "cpdCourses"),
      u.equalTo("sys.contentTypeId", "pgceCourses"),
      u.equalTo("sys.contentTypeId", "otherCourses")
    ),
    u.not(u.contains("entryTitle", "Dummy")),
    u.not(u.startsWith("entryTitle", "DevTest"))
  );
  n.pageSize = t, n.fields = [
    "entryTitle",
    "sys",
    "pageUrl",
    "seoStandardFields",
    "modules",
    "courseLength",
    "studyLevel",
    "coursesEntryRequirements.whichVariant",
    "coursesEntryRequirements.ucasPoints",
    "coursesVariant.whichVariant",
    "coursesVariant.ucasCode",
    "coursesVariant.studyMode"
  ];
  try {
    return await L.entries.search(n);
  } catch (r) {
    console.log(r);
  }
}, Yt = async (e, t = 3) => {
  const n = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("sys.dataFormat", "webpage"),
    u.equalTo("sys.metadata.includeInSearch", !0),
    u.contains("sys.uri", "/research/"),
    u.or(
      u.equalTo("entryTitle", e).weight(8),
      u.startsWith("entryTitle", e).weight(4),
      u.freeText("entryTitle", e, !0).weight(6),
      u.freeText("seoStandardFields.websiteDescription", e, !0).weight(2),
      u.freeText("seoStandardFields.description", e, !0).weight(2),
      u.freeText("seoStandardFields.keywords", e).weight(2),
      u.freeText("searchContent", e).weight(1)
    ),
    u.or(u.and(u.not(u.contains("entryTitle", "Dummy")), u.not(u.startsWith("entryTitle", "DevTest"))))
  );
  n.pageSize = t, n.fields = [
    "entryTitle",
    "title",
    "keywords",
    "description",
    "sys",
    "searchContent",
    "thumbnail",
    "sys.metadata.profileImage"
  ];
  try {
    return await L.entries.search(n);
  } catch (r) {
    console.log(r);
  }
}, bo = async (e, t = 3) => {
  const n = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("sys.dataFormat", "webpage"),
    u.equalTo("sys.metadata.includeInSearch", !0),
    u.equalTo("sys.contentTypeId", "staffProfilesWebpage"),
    u.or(
      u.equalTo("entryTitle", e).weight(8),
      u.startsWith("entryTitle", e).weight(4),
      u.freeText("entryTitle", e, !0).weight(6),
      u.freeText("seoStandardFields.websiteDescription", e, !0).weight(2),
      u.freeText("seoStandardFields.description", e, !0).weight(2),
      u.freeText("seoStandardFields.keywords", e).weight(2),
      u.freeText("searchContent", e).weight(1)
    )
  );
  n.pageSize = t, n.fields = [
    "entryTitle",
    "title",
    "keywords",
    "description",
    "sys",
    "searchContent",
    "thumbnail",
    "sys.metadata.profileImage"
  ];
  try {
    return await L.entries.search(n);
  } catch (r) {
    console.log(r);
  }
}, wo = async (e, t = 3) => {
  const n = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.and(u.equalTo("sys.contentTypeId", "newsArticles")),
    u.equalTo("sys.dataFormat", "entry"),
    u.contains("seoStandardFields.includeInSearch", "true"),
    u.or(
      u.equalTo("entryTitle", e).weight(8),
      u.startsWith("entryTitle", e).weight(4),
      u.freeText("entryTitle", e, !0).weight(6),
      u.freeText("seoStandardFields.websiteDescription", e, !0).weight(2),
      u.freeText("seoStandardFields.description", e, !0).weight(2),
      u.freeText("seoStandardFields.keywords", e).weight(2),
      u.freeText("searchContent", e).weight(1)
    ),
    u.and(
      u.not(u.equalTo("tags[]", "0/1/380/1039"))
      // hide teaching academy articles
    ),
    u.not(u.contains("entryTitle", "Dummy")),
    u.not(u.startsWith("entryTitle", "DevTest"))
  );
  n.pageSize = t, n.fields = ["entryTitle", "sys", "pageUrl", "seoStandardFields", "tags", "date"];
  try {
    return await L.entries.search(n);
  } catch (r) {
    console.log(r);
  }
}, Xt = "/assets/icon-library/standard/zoom.svg", xo = ({ type: e }) => {
  var x;
  const [t, n] = _(""), r = at(n, 500), o = 4;
  let s = "Type something...", c = null;
  switch (e == null ? void 0 : e.toLowerCase()) {
    case "courses":
      s = "Search for a course...", c = Ee(t, o);
      break;
    case "research":
      s = "Search all of our research...", c = Yt(t, o);
      break;
    default:
      c = Ee(t, o);
      break;
  }
  const { data: a, isFetched: f, isSuccess: d, refetch: g } = J({
    queryKey: [e, t],
    queryFn: () => c
  }), p = (h) => {
    var b;
    r((b = h == null ? void 0 : h.target) == null ? void 0 : b.value), g();
  }, v = {
    hidden: { opacity: 0, height: 0 },
    show: {
      opacity: 1,
      height: "auto",
      transition: {
        staggerChildren: 0.3
      }
    }
  }, w = {
    hidden: { opacity: 0 },
    show: { opacity: 1 }
  };
  return /* @__PURE__ */ S("div", { className: "w-full", children: [
    /* @__PURE__ */ i("div", { className: "flex", children: /* @__PURE__ */ i(
      "input",
      {
        style: {
          backgroundImage: `url(${Xt})`
        },
        className: "min-w-[280px] grow-[1] bg-white bg-[length:30px_auto] bg-[10px_center] bg-no-repeat py-2 pl-12 text-[18px] text-blue-d placeholder:text-blue-d-60 md:text-[20px]",
        onChange: p,
        type: "search",
        placeholder: s
      }
    ) }),
    f && d && t !== "" && /* @__PURE__ */ i(
      H.div,
      {
        variants: v,
        initial: "hidden",
        animate: "show",
        className: "flex max-h-full flex-col overflow-scroll bg-blue-d p-4 leading-tight",
        children: /* @__PURE__ */ S("ul", { className: "flex flex-col gap-4", children: [
          a && t !== "" && (a == null ? void 0 : a.items.map((h) => {
            var b, y, T;
            return /* @__PURE__ */ i(
              H.li,
              {
                variants: w,
                className: "group max-w-[86ch] cursor-pointer",
                children: /* @__PURE__ */ i(
                  "a",
                  {
                    href: h != null && h.pageUrl ? h == null ? void 0 : h.pageUrl : h == null ? void 0 : h.sys.uri,
                    className: "mb-1 group-hover:underline",
                    title: ((b = h == null ? void 0 : h.seoStandardFields) == null ? void 0 : b.title) || h.entryTitle,
                    children: /* @__PURE__ */ i("strong", { children: h != null && h.seoStandardFields ? (y = h == null ? void 0 : h.seoStandardFields) == null ? void 0 : y.title : h.entryTitle })
                  }
                )
              },
              (T = h == null ? void 0 : h.sys) == null ? void 0 : T.id
            );
          })),
          a && (a == null ? void 0 : a.totalCount) >= 3 && /* @__PURE__ */ i("li", { className: "border-t-white/8 mt-4 flex w-full grow justify-end border-t pt-5 hover:underline", children: /* @__PURE__ */ S(
            "a",
            {
              href: "/search/" + (e == null ? void 0 : e.toLowerCase()) + "?q=" + t,
              className: "flex items-center gap-[10px]",
              title: "See all results",
              children: [
                /* @__PURE__ */ i("strong", { children: "See all results" }),
                /* @__PURE__ */ i(
                  "svg",
                  {
                    width: "30",
                    height: "30",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 32 32",
                    children: /* @__PURE__ */ S(
                      "g",
                      {
                        strokeLinecap: "round",
                        strokeWidth: "2",
                        fill: "none",
                        stroke: "white",
                        strokeLinejoin: "round",
                        className: "nc-icon-wrapper",
                        children: [
                          /* @__PURE__ */ i(
                            "line",
                            {
                              "data-cap": "butt",
                              x1: "2",
                              y1: "16",
                              x2: "30",
                              y2: "16"
                            }
                          ),
                          " ",
                          /* @__PURE__ */ i("polyline", { points: "21,7 30,16 21,25 " })
                        ]
                      }
                    )
                  }
                )
              ]
            }
          ) }),
          a && ((x = a == null ? void 0 : a.items) == null ? void 0 : x.length) <= 0 && /* @__PURE__ */ S("li", { className: "max-w-[86ch]", children: [
            "Your query ",
            t && /* @__PURE__ */ i("strong", { children: '"' + t + '"' }),
            " ",
            "returned 0 results, please try a different search term"
          ] })
        ] })
      }
    )
  ] });
}, nt = it("button", {
  variants: {
    colour: {
      chartreuse: ["before:bg-char", "after:bg-char", "text-blue-d"],
      "ink blue": ["before:bg-blue-d", "after:bg-blue-d", "text-white"],
      "mid blue": ["before:bg-blue-m", "after:bg-blue-m", "text-white"],
      "light blue": ["before:bg-blue-l", "after:bg-blue-l", "text-blue-d"],
      green: ["before:bg-green", "after:bg-green", "text-blue-d"],
      purple: ["before:bg-purple", "after:bg-purple", "text-blue-d"],
      pink: ["before:bg-pink", "after:bg-pink", "text-blue-d"],
      orange: ["before:bg-orange", "after:bg-orange", "text-blue-d"],
      white: ["before:bg-white", "after:bg-white", "text-blue-d"]
    }
  },
  defaultVariants: {
    colour: "pink"
  }
}), To = ({ colour: e, ...t }) => {
  var n, r, o, s, c, a, f, d, g;
  return /* @__PURE__ */ i(
    "div",
    {
      className: [
        le(
          nt({ colour: e }),
          "relative w-full text-center sm:w-fit",
          "before:absolute before:left-0 before:top-1/2 before:z-[1] before:aspect-square before:h-3 before:-translate-y-1/2 before:transition-all",
          "after:absolute after:right-0 after:top-0 after:z-[0] after:h-full after:w-[calc(100%-15px)] after:transition-all",
          "focus-within:after:w-[calc(100%-30px)] hover:after:w-[calc(100%-30px)]"
        )
      ].join(" "),
      children: /* @__PURE__ */ i(
        "a",
        {
          href: ((n = t == null ? void 0 : t.btn) == null ? void 0 : n.externalLink) === null ? (o = (r = t == null ? void 0 : t.btn) == null ? void 0 : r.entry) == null ? void 0 : o.sys.uri : (s = t == null ? void 0 : t.btn) == null ? void 0 : s.externalLink,
          ...((c = t == null ? void 0 : t.btn) == null ? void 0 : c.ariaLabel) !== "" ? { "aria-label": (a = t == null ? void 0 : t.btn) == null ? void 0 : a.ariaLabel } : {},
          className: [
            le(
              nt({ colour: e }),
              "relative z-[1] block h-full px-6 py-4 text-tag font-bold uppercase leading-[1.5] no-underline outline-none transition-all md:text-base",
              "before:absolute before:left-0 before:top-0 before:h-[calc(100%/2-14px/2)] before:w-5 before:transition-all",
              "after:absolute after:bottom-0 after:left-0 after:h-[calc(100%/2-15px/2)] after:w-5 after:transition-all",
              "hover:pl-[40px] hover:text-current hover:before:left-[15px] hover:after:left-[15px]",
              "focus-within:pl-[40px] focus-within:before:left-[15px] focus-within:after:left-[15px]"
            )
          ].join(" "),
          ...(f = t == null ? void 0 : t.btn) != null && f.target ? { target: "_blank" } : {},
          ...(d = t == null ? void 0 : t.btn) != null && d.target ? { rel: "noreferrer nofollow" } : {},
          children: (g = t == null ? void 0 : t.btn) == null ? void 0 : g.label
        }
      )
    }
  );
}, Qt = ["seoStandardFields.title", "sys.uri", "pageUrl", "tags", "date"], So = ["entryTitle", "link", "dateTime"], Co = async () => {
  const e = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("seoStandardFields.includeInSearch", "true"),
    u.equalTo("sys.contentTypeId", "newsArticles"),
    u.and(u.not(u.equalTo("tags[]", "0/1/380/1039")))
  );
  e.pageSize = 4, e.fields = Qt, e.orderBy = Re.desc("date");
  try {
    return (await L.entries.search(e)).items;
  } catch (t) {
    console.log(t);
  }
}, No = async () => {
  const e = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("seoStandardFields.includeInSearch", "true"),
    u.equalTo("sys.contentTypeId", "newsArticles"),
    u.and(u.equalTo("tags[]", "0/1/380/503"))
  );
  e.pageSize = 4, e.fields = Qt, e.orderBy = Re.desc("date");
  try {
    return (await L.entries.search(e)).items;
  } catch (t) {
    console.log(t);
  }
}, Eo = async () => {
  const e = /* @__PURE__ */ new Date(), t = new B(
    u.equalTo("sys.versionStatus", "published"),
    u.equalTo("sys.contentTypeId", "eventsStandard"),
    u.greaterThanOrEqualTo("dateTime.from", e)
  );
  t.pageSize = 4, t.fields = So, t.orderBy = Re.asc("dateTime.from");
  try {
    return (await L.entries.search(t)).items;
  } catch (n) {
    console.log(n);
  }
}, rt = ({ sectData: e }) => {
  var s, c, a;
  let t = null, n = null;
  (s = e == null ? void 0 : e.sectionTitle) != null && s.toLowerCase().includes("research") ? (t = "ResearchNews", n = No()) : (t = e == null ? void 0 : e.type, n = (e == null ? void 0 : e.type) === "Events" ? Eo() : Co());
  const { data: r, isSuccess: o } = J({
    queryKey: [t],
    queryFn: () => n
  });
  return /* @__PURE__ */ S(
    "div",
    {
      className: [
        "flex h-auto max-h-[800px] basis-full flex-col lg:h-full lg:basis-[calc(50%-25px)]",
        `${t === "ResearchNews" ? "hidden lg:flex" : ""}`
      ].join(" "),
      children: [
        /* @__PURE__ */ i("p", { className: "mb-4 text-[14px] uppercase leading-[21px] tracking-[1.6px] opacity-80 md:mb-6 md:text-[16px]", children: e == null ? void 0 : e.sectionTitle }),
        /* @__PURE__ */ i("ul", { className: "flex grow flex-col gap-4 md:overflow-auto", children: o && (r == null ? void 0 : r.map((f, d) => {
          var g, p;
          return /* @__PURE__ */ i(
            "li",
            {
              className: "group max-h-[150px] grow bg-blue-d-60 hover:cursor-pointer",
              children: /* @__PURE__ */ S(
                "a",
                {
                  href: f.sys.uri !== null ? f.sys.uri : f.pageUrl || (f == null ? void 0 : f.link),
                  className: "flex flex-col p-4 font-bold ",
                  title: ((g = f == null ? void 0 : f.seoStandardFields) == null ? void 0 : g.title) || (f == null ? void 0 : f.entryTitle),
                  children: [
                    /* @__PURE__ */ i("p", { className: "mb-2 text-[14px] uppercase leading-[21px] tracking-[1.6px] md:text-[16px]", children: f != null && f.date ? We(f == null ? void 0 : f.date, "dd MMMM yyyy") : We(f == null ? void 0 : f.dateTime.from, "dd MMMM yyyy") }),
                    /* @__PURE__ */ i("span", { className: "line-clamp-3 group-hover:underline", children: ((p = f == null ? void 0 : f.seoStandardFields) == null ? void 0 : p.title) || (f == null ? void 0 : f.entryTitle) })
                  ]
                }
              )
            },
            d
          );
        })) }),
        (((c = e == null ? void 0 : e.uiPrimaryButtons) == null ? void 0 : c.label) !== null || ((a = e == null ? void 0 : e.uiPrimaryButtons) == null ? void 0 : a.entry) !== null) && /* @__PURE__ */ i("div", { className: "mt-6", children: /* @__PURE__ */ i(To, { btn: e == null ? void 0 : e.uiPrimaryButtons, colour: "white" }) })
      ]
    }
  );
};
function Io(e) {
  const t = e.fill || "currentColor", n = e.title || "right arrow", r = e.selected || !1;
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      className: [
        `${r && "translate-x-[10px]"}`,
        "h-[36px] w-[36px] transition-transform duration-300 group-hover/item:translate-x-[10px] md:h-[48px] md:w-[48px]"
      ].join(" "),
      children: [
        /* @__PURE__ */ i("title", { children: n }),
        /* @__PURE__ */ i(
          "g",
          {
            strokeLinecap: "square",
            strokeWidth: "4",
            fill: "none",
            stroke: t,
            strokeLinejoin: "miter",
            strokeMiterlimit: "10",
            children: /* @__PURE__ */ i("polyline", { points: "20,16 28,24 20,32 ", stroke: t })
          }
        )
      ]
    }
  );
}
function Ro(e) {
  const t = e.fill || "currentColor", n = e.title || "right arrow";
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      className: "h-[30px] w-[30px]",
      children: [
        /* @__PURE__ */ i("title", { children: n }),
        /* @__PURE__ */ i(
          "g",
          {
            strokeLinecap: "square",
            strokeWidth: "4",
            fill: "none",
            stroke: t,
            strokeLinejoin: "miter",
            strokeMiterlimit: "10",
            children: /* @__PURE__ */ i("polyline", { points: "28,32 20,24 28,16 ", stroke: t })
          }
        )
      ]
    }
  );
}
const ko = ({
  data: e,
  state: t
}) => {
  var a;
  const [n, r] = _(!1), o = t == null ? void 0 : t.selected, s = t.selectedHandler;
  ke(() => s(n ? e == null ? void 0 : e.title : void 0), [n]);
  function c(f) {
    f.currentTarget && r(!n);
  }
  if (e)
    return /* @__PURE__ */ i(Gt, { open: n, onOpenChange: r, modal: !1, children: /* @__PURE__ */ S("li", { children: [
      /* @__PURE__ */ S(
        Ht,
        {
          onClick: c,
          className: [
            `${o === void 0 && "opacity-100"}`,
            `${o !== (e == null ? void 0 : e.title) && "group-hover/list:opacity-60"}`,
            `${o !== void 0 && o !== (e == null ? void 0 : e.title) && "opacity-60"}`,
            "group/item flex w-full cursor-pointer items-center gap-2 text-[21px] font-bold transition-opacity duration-500 hover:!opacity-100 sm:text-h3"
          ].join(" "),
          value: e == null ? void 0 : e.title,
          title: (a = e == null ? void 0 : e.title) == null ? void 0 : a.toString(),
          children: [
            /* @__PURE__ */ i(De, { className: "hidden", children: e == null ? void 0 : e.title }),
            e == null ? void 0 : e.title,
            /* @__PURE__ */ i(Io, { fill: "white", title: "", selected: n })
          ]
        }
      ),
      /* @__PURE__ */ i(
        Le,
        {
          side: "left",
          className: [
            "no-overlay",
            "z-[51] flex h-[100vh] w-full flex-col gap-2 border-none bg-blue-d-80 p-0 pt-16 text-white data-[state=closed]:ease-in sm:pt-20 lg:z-[50] lg:!max-w-[calc(100vw-450px)] lg:translate-x-[450px]",
            `${(e == null ? void 0 : e.navigationArticles.length) > 0 && Object.keys(e == null ? void 0 : e.navigationArticles).length !== 0 ? "lg:w-[800px]" : "lg:w-[450px]"}`
          ].join(" "),
          title: (e == null ? void 0 : e.title) + " menu panel",
          children: /* @__PURE__ */ S("div", { className: "grid w-full gap-8 overflow-auto p-4 md:gap-10 md:px-10 md:pb-16 md:pt-6 lg:overflow-hidden", children: [
            /* @__PURE__ */ S(uo, { className: "flex w-fit cursor-pointer items-center bg-blue-d py-1 pr-2 text-[14px] uppercase tracking-[1.6px] lg:hidden", children: [
              /* @__PURE__ */ i(Ro, { fill: "white", title: "" }),
              /* @__PURE__ */ i("span", { children: "Main menu" })
            ] }),
            (e == null ? void 0 : e.showSearchBar) && (e == null ? void 0 : e.searchType) != null && /* @__PURE__ */ i(xo, { type: e == null ? void 0 : e.searchType }),
            /* @__PURE__ */ S("div", { className: "flex h-full min-h-32 flex-wrap gap-10 overflow-auto", children: [
              e && (e == null ? void 0 : e.navigationArticles.length) > 0 && /* @__PURE__ */ i(rt, { sectData: e && (e == null ? void 0 : e.navigationArticles[0]) }),
              (e == null ? void 0 : e.navigationArticles.length) > 1 && (e == null ? void 0 : e.navigationSecondaryLinks.length) === 0 && /* @__PURE__ */ i(rt, { sectData: e == null ? void 0 : e.navigationArticles[1] }),
              (e == null ? void 0 : e.navigationSecondaryLinks.length) > 0 && /* @__PURE__ */ i(yo, { data: e == null ? void 0 : e.navigationSecondaryLinks })
            ] })
          ] })
        }
      )
    ] }) });
}, Po = ({ data: e }) => {
  if (e)
    return /* @__PURE__ */ S("div", { className: "p-4 md:px-10 md:py-6", children: [
      /* @__PURE__ */ i("p", { className: "mb-6 text-[14px] uppercase leading-[21px] tracking-[1.6px] opacity-80 md:text-[16px]", children: "Quick links" }),
      /* @__PURE__ */ i("ul", { className: "mb-3 flex flex-col gap-3 md:mb-0 md:gap-4", children: e == null ? void 0 : e.map((t, n) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ S(
        "a",
        {
          href: t.entry ? t.entry.pageUrl : t.externalUrl,
          title: t.entry ? t.entry.entryTitle : t.externalTitle,
          target: t.newPage ? "_blank" : "",
          rel: t.newPage ? "noopener referrer" : "",
          className: "flex items-center gap-3 underline hover:no-underline",
          children: [
            /* @__PURE__ */ i(
              "img",
              {
                className: "w-4",
                src: "" + t.image.asset.sys.uri,
                alt: t.image.altText
              }
            ),
            t.entry ? t.entry.entryTitle : t.externalTitle
          ]
        }
      ) }, n)) })
    ] });
}, Ao = ({ data: e }) => {
  if (e)
    return /* @__PURE__ */ i("div", { className: "bg-blue-d-80 p-4 md:px-10 md:py-6", children: /* @__PURE__ */ i("ul", { className: "flex gap-4", children: e == null ? void 0 : e.map((t, n) => {
      var r;
      return /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i("a", { href: t.link, className: "block h-4 w-4", children: /* @__PURE__ */ i(
        "img",
        {
          className: "w-4",
          src: "" + t.image.asset.sys.uri,
          alt: t.image.altText,
          title: (r = t == null ? void 0 : t.title) == null ? void 0 : r.toString()
        }
      ) }) }, n);
    }) }) });
};
function Fo(e) {
  const t = e + "CollectionProvider", [n, r] = de(t), [o, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), c = (w) => {
    const { scope: x, children: h } = w, b = j.useRef(null), y = j.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ i(o, { scope: x, itemMap: y, collectionRef: b, children: h });
  };
  c.displayName = t;
  const a = e + "CollectionSlot", f = j.forwardRef(
    (w, x) => {
      const { scope: h, children: b } = w, y = s(a, h), T = M(x, y.collectionRef);
      return /* @__PURE__ */ i(Z, { ref: T, children: b });
    }
  );
  f.displayName = a;
  const d = e + "CollectionItemSlot", g = "data-radix-collection-item", p = j.forwardRef(
    (w, x) => {
      const { scope: h, children: b, ...y } = w, T = j.useRef(null), C = M(x, T), m = s(d, h);
      return j.useEffect(() => (m.itemMap.set(T, { ref: T, ...y }), () => void m.itemMap.delete(T))), /* @__PURE__ */ i(Z, { [g]: "", ref: C, children: b });
    }
  );
  p.displayName = d;
  function v(w) {
    const x = s(e + "CollectionConsumer", w);
    return j.useCallback(() => {
      const b = x.collectionRef.current;
      if (!b) return [];
      const y = Array.from(b.querySelectorAll(`[${g}]`));
      return Array.from(x.itemMap.values()).sort(
        (m, E) => y.indexOf(m.ref.current) - y.indexOf(E.ref.current)
      );
    }, [x.collectionRef, x.itemMap]);
  }
  return [
    { Provider: c, Slot: f, ItemSlot: p },
    v,
    r
  ];
}
var Oo = l.createContext(void 0);
function Zt(e) {
  const t = l.useContext(Oo);
  return e || t || "ltr";
}
var Te = "rovingFocusGroup.onEntryFocus", Mo = { bubbles: !1, cancelable: !0 }, he = "RovingFocusGroup", [Ie, Jt, Lo] = Fo(he), [Do, en] = de(
  he,
  [Lo]
), [_o, qo] = Do(he), tn = l.forwardRef(
  (e, t) => /* @__PURE__ */ i(Ie.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ i(Ie.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ i(Wo, { ...e, ref: t }) }) })
);
tn.displayName = he;
var Wo = l.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: c,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: f,
    onEntryFocus: d,
    preventScrollOnEntryFocus: g = !1,
    ...p
  } = e, v = l.useRef(null), w = M(t, v), x = Zt(s), [h = null, b] = Pe({
    prop: c,
    defaultProp: a,
    onChange: f
  }), [y, T] = l.useState(!1), C = q(d), m = Jt(n), E = l.useRef(!1), [P, N] = l.useState(0);
  return l.useEffect(() => {
    const I = v.current;
    if (I)
      return I.addEventListener(Te, C), () => I.removeEventListener(Te, C);
  }, [C]), /* @__PURE__ */ i(
    _o,
    {
      scope: n,
      orientation: r,
      dir: x,
      loop: o,
      currentTabStopId: h,
      onItemFocus: l.useCallback(
        (I) => b(I),
        [b]
      ),
      onItemShiftTab: l.useCallback(() => T(!0), []),
      onFocusableItemAdd: l.useCallback(
        () => N((I) => I + 1),
        []
      ),
      onFocusableItemRemove: l.useCallback(
        () => N((I) => I - 1),
        []
      ),
      children: /* @__PURE__ */ i(
        k.div,
        {
          tabIndex: y || P === 0 ? -1 : 0,
          "data-orientation": r,
          ...p,
          ref: w,
          style: { outline: "none", ...e.style },
          onMouseDown: R(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: R(e.onFocus, (I) => {
            const F = !E.current;
            if (I.target === I.currentTarget && F && !y) {
              const V = new CustomEvent(Te, Mo);
              if (I.currentTarget.dispatchEvent(V), !V.defaultPrevented) {
                const ge = m().filter((U) => U.focusable), Tn = ge.find((U) => U.active), Sn = ge.find((U) => U.id === h), Cn = [Tn, Sn, ...ge].filter(
                  Boolean
                ).map((U) => U.ref.current);
                on(Cn, g);
              }
            }
            E.current = !1;
          }),
          onBlur: R(e.onBlur, () => T(!1))
        }
      )
    }
  );
}), nn = "RovingFocusGroupItem", rn = l.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      ...c
    } = e, a = X(), f = s || a, d = qo(nn, n), g = d.currentTabStopId === f, p = Jt(n), { onFocusableItemAdd: v, onFocusableItemRemove: w } = d;
    return l.useEffect(() => {
      if (r)
        return v(), () => w();
    }, [r, v, w]), /* @__PURE__ */ i(
      Ie.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ i(
          k.span,
          {
            tabIndex: g ? 0 : -1,
            "data-orientation": d.orientation,
            ...c,
            ref: t,
            onMouseDown: R(e.onMouseDown, (x) => {
              r ? d.onItemFocus(f) : x.preventDefault();
            }),
            onFocus: R(e.onFocus, () => d.onItemFocus(f)),
            onKeyDown: R(e.onKeyDown, (x) => {
              if (x.key === "Tab" && x.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (x.target !== x.currentTarget) return;
              const h = jo(x, d.orientation, d.dir);
              if (h !== void 0) {
                if (x.metaKey || x.ctrlKey || x.altKey || x.shiftKey) return;
                x.preventDefault();
                let y = p().filter((T) => T.focusable).map((T) => T.ref.current);
                if (h === "last") y.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && y.reverse();
                  const T = y.indexOf(x.currentTarget);
                  y = d.loop ? $o(y, T + 1) : y.slice(T + 1);
                }
                setTimeout(() => on(y));
              }
            })
          }
        )
      }
    );
  }
);
rn.displayName = nn;
var Bo = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Uo(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function jo(e, t, n) {
  const r = Uo(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Bo[r];
}
function on(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function $o(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Vo = tn, zo = rn, _e = "Tabs", [Ko, hs] = de(_e, [
  en
]), sn = en(), [Go, qe] = Ko(_e), an = l.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: s,
      orientation: c = "horizontal",
      dir: a,
      activationMode: f = "automatic",
      ...d
    } = e, g = Zt(a), [p, v] = Pe({
      prop: r,
      onChange: o,
      defaultProp: s
    });
    return /* @__PURE__ */ i(
      Go,
      {
        scope: n,
        baseId: X(),
        value: p,
        onValueChange: v,
        orientation: c,
        dir: g,
        activationMode: f,
        children: /* @__PURE__ */ i(
          k.div,
          {
            dir: g,
            "data-orientation": c,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
an.displayName = _e;
var ln = "TabsList", cn = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, s = qe(ln, n), c = sn(n);
    return /* @__PURE__ */ i(
      Vo,
      {
        asChild: !0,
        ...c,
        orientation: s.orientation,
        dir: s.dir,
        loop: r,
        children: /* @__PURE__ */ i(
          k.div,
          {
            role: "tablist",
            "aria-orientation": s.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
cn.displayName = ln;
var un = "TabsTrigger", dn = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...s } = e, c = qe(un, n), a = sn(n), f = gn(c.baseId, r), d = pn(c.baseId, r), g = r === c.value;
    return /* @__PURE__ */ i(
      zo,
      {
        asChild: !0,
        ...a,
        focusable: !o,
        active: g,
        children: /* @__PURE__ */ i(
          k.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": g,
            "aria-controls": d,
            "data-state": g ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: f,
            ...s,
            ref: t,
            onMouseDown: R(e.onMouseDown, (p) => {
              !o && p.button === 0 && p.ctrlKey === !1 ? c.onValueChange(r) : p.preventDefault();
            }),
            onKeyDown: R(e.onKeyDown, (p) => {
              [" ", "Enter"].includes(p.key) && c.onValueChange(r);
            }),
            onFocus: R(e.onFocus, () => {
              const p = c.activationMode !== "manual";
              !g && !o && p && c.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
dn.displayName = un;
var fn = "TabsContent", hn = l.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: s, ...c } = e, a = qe(fn, n), f = gn(a.baseId, r), d = pn(a.baseId, r), g = r === a.value, p = l.useRef(g);
    return l.useEffect(() => {
      const v = requestAnimationFrame(() => p.current = !1);
      return () => cancelAnimationFrame(v);
    }, []), /* @__PURE__ */ i(ee, { present: o || g, children: ({ present: v }) => /* @__PURE__ */ i(
      k.div,
      {
        "data-state": g ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !v,
        id: d,
        tabIndex: 0,
        ...c,
        ref: t,
        style: {
          ...e.style,
          animationDuration: p.current ? "0s" : void 0
        },
        children: v && s
      }
    ) });
  }
);
hn.displayName = fn;
function gn(e, t) {
  return `${e}-trigger-${t}`;
}
function pn(e, t) {
  return `${e}-content-${t}`;
}
var Ho = an, vn = cn, mn = dn, yn = hn;
const Yo = Ho, bn = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  vn,
  {
    ref: n,
    className: W(
      "inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
      e
    ),
    ...t
  }
));
bn.displayName = vn.displayName;
const wn = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  mn,
  {
    ref: n,
    className: W(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-slate-950 data-[state=active]:shadow-sm dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 dark:data-[state=active]:bg-slate-950 dark:data-[state=active]:text-slate-50",
      e
    ),
    ...t
  }
));
wn.displayName = mn.displayName;
const xn = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  yn,
  {
    ref: n,
    className: W(
      "mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
      e
    ),
    ...t
  }
));
xn.displayName = yn.displayName;
const Xo = ({
  state: e
}) => {
  const t = e.searchHandler, [n, r] = _(""), [o, s] = _("All"), c = at(r, 500), a = ["All", "Courses", "Research", "Staff", "News"];
  let f = null;
  switch (o.toLowerCase()) {
    case "all":
      f = tt(n);
      break;
    case "courses":
      f = Ee(n);
      break;
    case "research":
      f = Yt(n);
      break;
    case "staff":
      f = bo(n);
      break;
    case "news":
      f = wo(n);
      break;
    default:
      f = tt(n);
      break;
  }
  const { data: d, isFetched: g, isSuccess: p, refetch: v } = J({
    queryKey: [o, n],
    queryFn: () => f
  }), w = (y) => {
    var T;
    c((T = y == null ? void 0 : y.target) == null ? void 0 : T.value), v();
  };
  ke(() => d && n != "" ? t(!0) : t(!1), [n, d]);
  const x = {
    hidden: { opacity: 0, height: 0 },
    show: {
      opacity: 1,
      height: "auto"
    }
  }, h = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  }, b = {
    hidden: { opacity: 0 },
    show: { opacity: 1 }
  };
  return /* @__PURE__ */ S("div", { className: "h-auto p-4 md:p-10", children: [
    /* @__PURE__ */ i("p", { className: "mb-4 text-[14px] uppercase leading-[21px] tracking-[1.6px] opacity-80 md:mb-6 md:text-[16px]", children: "Search our website" }),
    /* @__PURE__ */ i("div", { className: "flex ", children: /* @__PURE__ */ i(
      "input",
      {
        style: {
          backgroundImage: `url(${Xt})`
        },
        className: "min-w-[280px] grow-[1] bg-white bg-[length:30px_auto] bg-[10px_center] bg-no-repeat py-2 pl-12 text-blue-d placeholder:text-blue-d-60 md:text-h4",
        onChange: w,
        type: "search",
        placeholder: "Type something..."
      }
    ) }),
    n !== "" && /* @__PURE__ */ i(
      H.div,
      {
        variants: x,
        initial: "hidden",
        animate: "show",
        className: "mt-4 flex max-h-full flex-col overflow-scroll leading-tight md:mt-10",
        children: /* @__PURE__ */ S(Yo, { defaultValue: o.toLowerCase(), children: [
          /* @__PURE__ */ i(bn, { className: "flex h-auto w-full flex-row justify-start overflow-x-auto rounded-none p-0", children: a.map((y, T) => /* @__PURE__ */ i(
            wn,
            {
              value: y.toLowerCase(),
              onClick: (C) => {
                var m;
                s(y), (m = C.currentTarget) == null || m.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                  inline: "center"
                });
              },
              className: "text-md grow rounded-none p-4 font-bold data-[state=active]:bg-blue-d-80",
              children: y
            },
            T
          )) }),
          a.map((y, T) => {
            var C;
            return /* @__PURE__ */ i(
              xn,
              {
                value: y.toLowerCase(),
                className: "mt-0 min-h-[500px] bg-blue-d-80 p-4 md:p-6 [&:not([hidden])]:flex",
                children: g && p && /* @__PURE__ */ S(
                  H.ul,
                  {
                    variants: h,
                    initial: "hidden",
                    animate: "show",
                    className: "flex w-full flex-col gap-4",
                    children: [
                      d && n !== "" && (d == null ? void 0 : d.items.map(
                        (m, E) => {
                          var P, N, I, F;
                          return E < 3 && /* @__PURE__ */ i(
                            H.li,
                            {
                              variants: b,
                              className: "border-b-white/8 group max-w-[86ch] cursor-pointer border-b pb-5",
                              children: /* @__PURE__ */ S(
                                "a",
                                {
                                  href: m != null && m.pageUrl ? m == null ? void 0 : m.pageUrl : m == null ? void 0 : m.sys.uri,
                                  title: ((P = m == null ? void 0 : m.seoStandardFields) == null ? void 0 : P.title) || m.entryTitle,
                                  children: [
                                    /* @__PURE__ */ i("h2", { className: "mb-2 line-clamp-1 group-hover:underline md:text-lg", children: /* @__PURE__ */ i("strong", { children: m != null && m.seoStandardFields ? (N = m == null ? void 0 : m.seoStandardFields) == null ? void 0 : N.title : m.entryTitle }) }),
                                    m != null && m.seoStandardFields ? /* @__PURE__ */ i(
                                      "div",
                                      {
                                        className: "line-clamp-2",
                                        dangerouslySetInnerHTML: {
                                          __html: Be(
                                            (I = m == null ? void 0 : m.seoStandardFields) == null ? void 0 : I.websiteDescription
                                          )
                                        }
                                      }
                                    ) : /* @__PURE__ */ i(
                                      "div",
                                      {
                                        className: "line-clamp-2",
                                        dangerouslySetInnerHTML: {
                                          __html: Be(m == null ? void 0 : m.description)
                                        }
                                      }
                                    )
                                  ]
                                }
                              )
                            },
                            (F = m == null ? void 0 : m.sys) == null ? void 0 : F.id
                          );
                        }
                      )),
                      d && (d == null ? void 0 : d.totalCount) >= 3 && /* @__PURE__ */ i("li", { className: "flex grow items-end self-end hover:underline", children: /* @__PURE__ */ S(
                        "a",
                        {
                          href: y.toLowerCase() === "all" ? "/search/?q=" + n : "/search/" + y.toLowerCase() + "?q=" + n,
                          className: "flex items-center justify-end gap-[10px]",
                          title: "See all results",
                          children: [
                            /* @__PURE__ */ i("strong", { children: "See all results" }),
                            /* @__PURE__ */ i(
                              "svg",
                              {
                                width: "30",
                                height: "30",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 32 32",
                                children: /* @__PURE__ */ S(
                                  "g",
                                  {
                                    strokeLinecap: "round",
                                    strokeWidth: "2",
                                    fill: "none",
                                    stroke: "white",
                                    strokeLinejoin: "round",
                                    className: "nc-icon-wrapper",
                                    children: [
                                      /* @__PURE__ */ i(
                                        "line",
                                        {
                                          "data-cap": "butt",
                                          x1: "2",
                                          y1: "16",
                                          x2: "30",
                                          y2: "16"
                                        }
                                      ),
                                      " ",
                                      /* @__PURE__ */ i("polyline", { points: "21,7 30,16 21,25 " })
                                    ]
                                  }
                                )
                              }
                            )
                          ]
                        }
                      ) }),
                      d && ((C = d == null ? void 0 : d.items) == null ? void 0 : C.length) <= 0 && /* @__PURE__ */ S("li", { className: "max-w-[86ch] border-b border-b-white py-5", children: [
                        "Your query",
                        " ",
                        n && /* @__PURE__ */ i("strong", { children: '"' + n + '"' }),
                        " ",
                        "returned 0 results, please try a different search term"
                      ] })
                    ]
                  }
                )
              },
              T
            );
          })
        ] })
      }
    )
  ] });
}, Qo = ({ data: e }) => {
  if (e)
    return /* @__PURE__ */ S(
      H.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        className: "px-4 py-6 md:px-10",
        children: [
          /* @__PURE__ */ i("p", { className: "mb-4 text-[14px] uppercase leading-[21px] tracking-[1.6px] opacity-80 md:mb-6 md:text-[16px]", children: "Popular searches" }),
          /* @__PURE__ */ i("ul", { className: "flex flex-wrap", children: e == null ? void 0 : e.map((t, n) => /* @__PURE__ */ i("li", { className: "mb-4 basis-1/2 md:mb-2", children: /* @__PURE__ */ i(
            "a",
            {
              href: "/search/?q=" + (t == null ? void 0 : t.replaceAll(" ", "+")),
              className: "flex items-center gap-3 hover:underline",
              title: t,
              children: t
            }
          ) }, n)) })
        ]
      }
    );
}, ot = ({ type: e, data: t }) => {
  var p;
  const [n, r] = _(!1), [o, s] = _(void 0), [c, a] = _(!1);
  ke(() => {
    var v, w;
    n ? (document.body.classList.add("overflow-hidden"), (v = document.getElementById("header")) == null || v.classList.add("!bg-[length:100%_0]", "!duration-75", "!delay-0")) : (document.body.classList.remove("overflow-hidden"), (w = document.getElementById("header")) == null || w.classList.remove("!bg-[length:100%_0]", "!duration-75", "!delay-0"));
  }, [n]);
  function f(v) {
    v.currentTarget && r(!n);
  }
  function d(v) {
    s(v);
  }
  function g(v) {
    a(v);
  }
  return /* @__PURE__ */ S(Gt, { open: n, onOpenChange: r, modal: !1, children: [
    /* @__PURE__ */ S(
      Ht,
      {
        onClick: f,
        id: e,
        className: [
          `${e} ${n ? "active" : ""}`,
          "flex h-8 w-8 cursor-pointer items-center justify-center transition-colors duration-300 sm:h-12 sm:w-12"
        ].join(" "),
        children: [
          /* @__PURE__ */ i(De, { className: "hidden", children: e }),
          e === "menu" && /* @__PURE__ */ i(
            vo,
            {
              fill: "white",
              secondaryfill: "white",
              title: "Main menu"
            }
          ),
          e === "search" && /* @__PURE__ */ i(mo, { fill: "white", secondaryfill: "white", title: "Search" })
        ]
      }
    ),
    /* @__PURE__ */ i(
      Le,
      {
        side: "left",
        className: [
          `${e === "search" ? "sm:max-w-full md:max-w-[850px]" : "md:max-w-[450px]"}`,
          "z-[51] h-[100vh] w-full max-w-[100vw] border-none bg-blue-d p-0 pt-16 text-white shadow-none data-[state=closed]:ease-in sm:pt-20"
        ].join(" "),
        title: e + " panel",
        children: /* @__PURE__ */ S("div", { className: "flex h-full flex-col overflow-y-scroll", children: [
          e === "menu" && /* @__PURE__ */ S(Q, { children: [
            /* @__PURE__ */ i("ul", { className: "group/list m-4 flex grow flex-col gap-3 sm:gap-4 md:m-10", children: (p = t == null ? void 0 : t.navItems) == null ? void 0 : p.map((v, w) => /* @__PURE__ */ i(
              ko,
              {
                data: v,
                state: { selected: o, selectedHandler: d }
              },
              w
            )) }),
            /* @__PURE__ */ i(Po, { data: t == null ? void 0 : t.quickLinks }),
            /* @__PURE__ */ i(Ao, { data: t == null ? void 0 : t.socialIcons })
          ] }),
          e === "search" && /* @__PURE__ */ S(Q, { children: [
            /* @__PURE__ */ i(Xo, { state: { searchHandler: g } }),
            !c && /* @__PURE__ */ i(Qo, { data: t == null ? void 0 : t.popularSearches })
          ] })
        ] })
      }
    )
  ] });
}, gs = () => {
  const { error: e, data: t } = J({
    queryKey: ["navigation"],
    queryFn: () => lt()
  });
  if (e) return "An error has occurred: " + e.message;
  const n = (t == null ? void 0 : t.secondaryLogo) || null, r = (t == null ? void 0 : t.navItems) || null, o = (t == null ? void 0 : t.quickLinks) || null, s = (t == null ? void 0 : t.socialIcons) || null, c = (t == null ? void 0 : t.popularSearches) || null;
  return /* @__PURE__ */ S("nav", { className: "absolute z-[52] flex h-14 w-full justify-between bg-gradient-to-b from-black/70 bg-[length:100%_100%] bg-no-repeat px-4 transition-[background-size] delay-150 duration-500 ease-in-out sm:h-[110px] lg:px-10", children: [
    /* @__PURE__ */ S("div", { className: "z-[10] flex items-center gap-2", children: [
      /* @__PURE__ */ i("a", { href: "/", children: /* @__PURE__ */ i(
        "img",
        {
          className: "h-10 w-auto sm:h-16",
          alt: "The University of Hull",
          src: "//www.hull.ac.uk/assets/developer/static-templates/header/images/new/uoh-white.svg",
          width: "150",
          height: "95"
        }
      ) }),
      (n == null ? void 0 : n.logo) && /* @__PURE__ */ i(
        "a",
        {
          href: n == null ? void 0 : n.link,
          className: "border-l border-solid border-white pl-2",
          title: n == null ? void 0 : n.ariaLabel,
          children: /* @__PURE__ */ i(
            "img",
            {
              className: "h-8 w-auto sm:h-12",
              alt: n == null ? void 0 : n.logo.altText,
              src: n == null ? void 0 : n.logo.asset.sys.uri
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ S(
      "div",
      {
        "aria-label": "Main",
        className: "relative z-[11] flex items-center justify-end gap-2 md:gap-0",
        children: [
          /* @__PURE__ */ i(ot, { type: "menu", data: { navItems: r, quickLinks: o, socialIcons: s } }),
          /* @__PURE__ */ i(ot, { type: "search", data: { popularSearches: c } })
        ]
      }
    )
  ] });
}, Zo = it("section", {
  variants: {
    background: {
      white: ["bg-white", "text-blue-d"],
      chartreuse: ["bg-char", "text-blue-d"],
      "ink blue": ["bg-blue-d", "text-white"],
      "mid blue": ["bg-blue-m", "text-white"],
      "light blue": ["bg-blue-l", "text-blue-d"],
      green: ["bg-green", "text-blue-d"],
      purple: ["bg-purple", "text-blue-d"],
      pink: ["bg-pink", "text-blue-d"],
      orange: ["bg-orange", "text-blue-d"]
    },
    border: {
      white: ["border-white"],
      chartreuse: ["border-char"],
      "ink blue": ["border-blue-d"],
      "mid blue": ["border-blue-m"],
      "light blue": ["border-blue-l"],
      green: ["border-green"],
      purple: ["border-purple"],
      pink: ["border-pink"],
      orange: ["border-orange"]
    }
  }
}), ps = () => {
  const { error: e, data: t } = J({
    queryKey: ["navigation"],
    queryFn: () => lt()
  });
  if (e) return "An error has occurred: " + e.message;
  const n = (t == null ? void 0 : t.footer) || null;
  return /* @__PURE__ */ i(
    "footer",
    {
      id: "footer",
      className: [le(Zo({ background: "ink blue" })), ""].join(" "),
      children: /* @__PURE__ */ S("div", { className: "container grid auto-cols-auto auto-rows-auto items-center gap-[30px] sm:gap-[40px] lg:gap-[50px]", children: [
        /* @__PURE__ */ i("div", { className: "col-start-1 row-start-1", children: /* @__PURE__ */ i("a", { href: "https://www.hull.ac.uk/", className: "", children: /* @__PURE__ */ i(
          "img",
          {
            className: "max-h-[50px] min-w-[150px] md:max-h-[100px]",
            src: "https://www.hull.ac.uk/assets/developer/static-templates/header/images/new/uoh-white.svg",
            alt: "The University of Hull",
            width: "300",
            height: "100"
          }
        ) }) }),
        /* @__PURE__ */ i("div", { className: "col-start-2 row-start-1 flex justify-end gap-[30px] sm:gap-[50px]", children: n == null ? void 0 : n.awardsPartners.map((r, o) => /* @__PURE__ */ i("a", { href: r == null ? void 0 : r.link, className: "", children: /* @__PURE__ */ i(
          "img",
          {
            className: "h-[100px] max-h-[50px] sm:max-h-[100px]",
            src: (process.env.NODE_ENV === "development" ? "https://preview-uni-hull.cloud.contensis.com" : "") + (r == null ? void 0 : r.logo.asset.sys.uri),
            alt: r == null ? void 0 : r.logo.altText,
            width: "80",
            height: "100"
          }
        ) }, o)) }),
        /* @__PURE__ */ S("div", { className: "col-span-2 col-start-1 row-start-3 flex flex-col gap-[10px] lg:col-span-1", children: [
          /* @__PURE__ */ i("p", { className: "", children: n == null ? void 0 : n.address }),
          /* @__PURE__ */ i(
            "a",
            {
              href: (n == null ? void 0 : n.phone) && "tel:" + (n == null ? void 0 : n.phone.replace("(0)", "").replaceAll(" ", "")),
              className: "no-underline hover:underline",
              children: n == null ? void 0 : n.phone
            }
          )
        ] }),
        /* @__PURE__ */ i("ul", { className: "col-span-2 col-start-1 row-start-4 flex flex-wrap gap-x-[20px] gap-y-[10px] sm:gap-[30px] lg:col-span-1 lg:col-start-2 lg:row-start-3 lg:flex-row lg:justify-end", children: n == null ? void 0 : n.uiLinks.map((r, o) => {
          var s;
          return /* @__PURE__ */ i("li", { className: "underline hover:no-underline", children: /* @__PURE__ */ i(
            "a",
            {
              href: ((s = r == null ? void 0 : r.entry) == null ? void 0 : s.pageUrl) || (r == null ? void 0 : r.externalLink),
              target: r != null && r.target ? "_blank" : "",
              children: r == null ? void 0 : r.label
            }
          ) }, o);
        }) }),
        /* @__PURE__ */ i("ul", { className: "col-span-2 col-start-1 row-start-6 flex flex-wrap gap-x-[20px] gap-y-[10px] lg:col-span-1 lg:col-start-2 lg:row-start-5 lg:flex-row lg:justify-end lg:gap-[20px]", children: n == null ? void 0 : n.entry.map((r, o) => /* @__PURE__ */ i("li", { className: "underline hover:no-underline", children: /* @__PURE__ */ i("a", { href: r == null ? void 0 : r.pageUrl, className: "!text-[14px] sm:!text-[15px]", children: r == null ? void 0 : r.entryTitle }) }, o)) }),
        /* @__PURE__ */ S("div", { className: "col-span-2 col-start-1 row-start-7 text-[14px] sm:text-[15px] lg:col-span-1 lg:row-start-5", children: [
          "© University of Hull, ",
          (/* @__PURE__ */ new Date()).getFullYear()
        ] }),
        /* @__PURE__ */ i("div", { className: "col-span-2 col-start-1 row-start-2 h-[1px] w-full bg-white" }),
        /* @__PURE__ */ i("div", { className: "col-span-2 col-start-1 row-start-5 h-[1px] w-full bg-white lg:row-start-4" })
      ] })
    }
  );
};
export {
  To as Button,
  ps as Footer,
  gs as Navigation
};
